import { Breakpoint, Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React, { FC } from 'react';

import { Icon, IconTheme, IconType } from 'src/components/icons';
import { i18n } from 'src/i18n';
import { strommeboxLeftPictureProps } from 'src/resources/picture';
import { navigationService } from 'src/services/navigation-service';

import {
  StyledEditIcon,
  StyledContainer,
  StyledDeleteButton,
  StyledEditButton,
  StyledImage,
  StyledSetupPrice,
  StyledProductContainer,
  StyledProductInformation,
  StyledQuantityRow,
  StyledQuantityText,
  StyledTitleContainer,
} from './product-information.styled';

interface Props {
  count: number;
  name: string;
  linkToEdit: string;
  monthlyCost: string;
  setupCost: string;
  setupCostLabel: string;
  onRemove: () => void;
}

export const ProductInformation: FC<Props> = (props) => {
  const { count, name, linkToEdit, monthlyCost, setupCost, setupCostLabel, onRemove } = props;

  return (
    <StyledProductContainer>
      <StyledImage {...strommeboxLeftPictureProps} />
      <StyledProductInformation>
        <StyledTitleContainer>
          <Typography variant="paragraph2" component="p">
            {name}
          </Typography>
          <StyledDeleteButton onClick={onRemove}>
            <Icon iconType={IconType.BIN} iconTheme={IconTheme.DARK} />
          </StyledDeleteButton>
        </StyledTitleContainer>
        <Typography variant="paragraph3" component="p">
          {monthlyCost}
        </Typography>
        <StyledQuantityRow>
          <span>
            <StyledSetupPrice variant="paragraph3" component="span" maxBreakpoint={Breakpoint.TABLET} italic={true}>
              {setupCost}
            </StyledSetupPrice>
            <StyledSetupPrice variant="paragraph3" component="span" maxBreakpoint={Breakpoint.TABLET} italic={true}>
              {setupCostLabel}
            </StyledSetupPrice>
          </span>

          <StyledContainer>
            <StyledQuantityText variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
              {i18n.page.summary.productInformation.quantityLabel}
            </StyledQuantityText>

            <Typography variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
              {count}
            </Typography>
            <StyledEditButton onClick={() => navigationService.goToPath(linkToEdit)}>
              <StyledEditIcon iconType={IconType.EDIT} iconTheme={IconTheme.DARK} />
            </StyledEditButton>
          </StyledContainer>
        </StyledQuantityRow>
      </StyledProductInformation>
    </StyledProductContainer>
  );
};
